<template>
	<div>
		<el-select v-model="notice" placeholder="请选择" style="width: 1100px;">
			<el-option
				v-for="item in list"
				:key="item.follow_desc"
				:label="item.follow_desc"
				:value="item.follow_desc">
			</el-option>
		</el-select>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				notice:'',
				list:[
					{
						id:0,
						follow_desc:'',
					}
				]
			}
		},
		// watch:{
		// 	timestamp(_new, _old){
		// 		this.getList()
		// 	}
		// },
		created() {
			this.getFollowDescList()
		},
		methods:{
			getFollowDescList(){
				let _this  = this;
				const _loading = this.$loading({ lock: true, text: '加载宣言中..', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Virtuals/getFollowDesc", {}).then(res=>{
					_loading.close();
					if(res.code == 200){
						_this.list = res.data.list;
					}
				}).catch(err=>{
					_loading.close();
				})
			}
		}
	}
</script>

<style>
</style>